module.exports = __webpack_public_path__ + "static/media/bg_introduction.a8e68daf.png";